module.exports = __webpack_public_path__ + "static/media/companySixbg.fa6b02a7.png";